/* Radiobuttons */
$(document).on('change', '.__radio input', function () {
    if ($(this).is(':checked')) {
        $(this)
            .closest('.__radio')
            .find('.input_wrap > label')
            .removeClass('__checked');
        $(this)
            .parent()
            .addClass('__checked');
    }
});
$('.__radio input:checked')
    .parent()
    .addClass('__checked');

/* Checkboxes */
$(document).on('change', '.__checkbox input', function () {
    if ($(this).is(':checked')) {
        $(this)
            .parent()
            .addClass('__checked');
    } else {
        $(this)
            .parent()
            .removeClass('__checked');
    }
});
$('.__checkbox input:checked')
    .parent()
    .addClass('__checked');

/* Focus state */
$(document).ready(function () {
    $('.field_wrap.__radio input').focus(function () {
        $(this)
            .closest('label')
            .addClass('__focused');
    }).blur(function () {
        $(this)
            .closest('label')
            .removeClass('__focused');
    });
    $('.field_wrap.__checkbox input').focus(function () {
        $(this)
            .closest('label')
            .addClass('__focused');
    }).blur(function () {
        $(this)
            .closest('label')
            .removeClass('__focused');
    });
});

// Select
$('.__select select').each(function () {
    var thisElement = $(this).parent();
    $(this).select2({
        containerCssClass: 'select2-css',
        minimumResultsForSearch: Infinity,
        dropdownParent: thisElement,
    });
});

// Date picker
flatpickr(".__date input", {
    altInput: true, // creates new visual input
    altFormat: "F j, Y", // sets the format to be more friendly, i.e. Thursday 8th April 2021
    dateFormat: "Y-m-d", // sets the format to match server-side data i.e. 2021-04-08
});

// Time picker
flatpickr(".__time input", {
    enableTime: true,
    noCalendar: true,
    time_24hr: true,
    altInput: true, // creates new visual input
    altFormat: "F j, Y", // sets the format to be more friendly, i.e. Thursday 8th April 2021
    dateFormat: "Y-m-d", // sets the format to match server-side data i.e. 2021-04-08
});

// Date and time picker
flatpickr(".__datetime input", {
    enableTime: true,
    altInput: true, // creates new visual input
    altFormat: "F j, Y", // sets the format to be more friendly, i.e. Thursday 8th April 2021
    dateFormat: "Y-m-d", // sets the format to match server-side data i.e. 2021-04-08
});